import { useApi } from '@/providers/ApiContextProvider/ApiContextProvider';
import { useQuery } from '@tanstack/react-query';
import { ENTITY_IDS_KEY } from '@/api/constants/queryKeys';
import { STATIC_DATA_QUERY_OPTIONS } from '@/api/constants/queryOptions';
import { handleCatch } from '@/api/helpers';
import { IAuthenticatedQueryOptions } from '@/api/sharedTypes';
import { IEntity, IEntityDetailsDto } from '@/types/entities';
import { IGetEntityDetailsRequest } from '@/api/entityIds/entityIds.types';

export const useGetUniqueEntitiesList = ({ isAuthenticated }: IAuthenticatedQueryOptions) => {
  const { entityIdsApi } = useApi();

  const {
    data: fetchedEntitiesList,
    error,
    isLoading,
  } = useQuery<IEntity[], Error>({
    queryKey: [ENTITY_IDS_KEY, 'GET_ALIVE'],
    queryFn: () => {
      return entityIdsApi.getUniqueEntitiesList().catch(error => {
        return handleCatch(error, `load the entities list`);
      });
    },
    ...STATIC_DATA_QUERY_OPTIONS,
    enabled: isAuthenticated,
  });

  return {
    fetchedEntitiesList,
    error,
    isLoading,
  };
};

export const useGetEntityDetails = ({ agioId, isBetaUserFeature }: IGetEntityDetailsRequest) => {
  const { entityIdsApi } = useApi();

  const {
    data: fetchedEntityDetails,
    error,
    isLoading,
  } = useQuery<IEntityDetailsDto, Error>({
    queryKey: [ENTITY_IDS_KEY, 'GET_ENTITY_DETAILS', agioId, isBetaUserFeature],
    queryFn: () => {
      return entityIdsApi.getEntityDetails({ agioId, isBetaUserFeature }).catch(error => {
        return handleCatch(error, `load entity details data`);
      });
    },
    ...STATIC_DATA_QUERY_OPTIONS,
    refetchInterval: 3600000, // 1 hour background refresh
    enabled: !!agioId && isBetaUserFeature !== false,
  });

  return {
    fetchedEntityDetails,
    error,
    isLoading,
  };
};
